import React from "react";

export default function Badge({ children, tone = "neutral" }) {
  const styles = {
    neutral: {
      bg: "rgba(148,163,184,.15)",
      bd: "rgba(148,163,184,.25)",
      fg: "#9AA7B5",
    },
    verified: {
      bg: "rgba(34,197,94,.12)",
      bd: "rgba(34,197,94,.3)",
      fg: "#34D399",
    },
    alert: {
      bg: "rgba(245,158,11,.12)",
      bd: "rgba(245,158,11,.3)",
      fg: "#FBBF24",
    },
  }[tone];
  return (
    <span
      style={{
        background: styles.bg,
        border: `1px solid ${styles.bd}`,
        color: styles.fg,
      }}
      className="px-2 py-1 rounded"
    >
      <span
        style={{
          fontFamily: "ui-monospace, Menlo, monospace",
          fontSize: 10,
          fontWeight: 800,
          letterSpacing: 1,
        }}
      >
        {children}
      </span>
    </span>
  );
}
